import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationGallery } from '../../components/locations/LocationGallery';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function MidlandPage() {
  const location = getLocationById('midland');
  if (!location) {
    return <div data-id="element-961">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-962">
      <Header data-id="element-963" />

      <main data-id="element-964">
        <LocationPageHero location={location} data-id="element-965" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-966" />
        {location.galleryImages && location.galleryImages.length > 0 && <LocationGallery images={location.galleryImages} locationName={location.name} data-id="element-967" />}
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-968" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-969" />
      </main>

      <Footer data-id="element-970" />
    </div>;
}